import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, GraduationCap, Compass, Sigma, Sparkles } from "lucide-react";

const ITEMS = [
  { label: "Ebeveynliğimi", icon: Heart, to: "/programlar/bilgece-ebeveynlik", desc: "Bilgece Ebeveynlik" },
  { label: "Öğretmenliğimi", icon: GraduationCap, to: "/programlar/bilgece-ogretmenlik-akademisi", desc: "Öğretmenlik Akademisi" },
  { label: "Liderliğimi", icon: Compass, to: "/programlar/bilgece-liderlik", desc: "Bilgece Liderlik" },
  { label: "Çocuğumun öğrenmesini", icon: Sigma, to: "/programlar/bilgece-matematik", desc: "Bilgece Matematik" },
  { label: "Kendimi", icon: Sparkles, to: "/programlar/bilgece-atolye", desc: "Bilgece Atölye" },
];

export function TransformationCards() {
  return (
    <div data-testid="transformation-cards" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
      {ITEMS.map((it, i) => {
        const Icon = it.icon;
        return (
          <motion.div
            key={it.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
          >
            <Link
              to={it.to}
              data-testid={`transform-card-${i}`}
              className="group block h-full bg-brand-cream border border-brand-gold-light/40 rounded-sm p-7 transition-transform duration-300 hover:-translate-y-1.5 hover:border-brand-gold"
            >
              <Icon className="text-brand-gold group-hover:text-brand-green transition-colors" size={30} strokeWidth={1.4} />
              <h3 className="font-serif text-2xl text-brand-green mt-6 leading-tight">{it.label}</h3>
              <p className="text-brand-text/60 text-xs mt-3 tracking-wide">{it.desc} →</p>
            </Link>
          </motion.div>
        );
      })}
    </div>
  );
}
